export type SoundNames = 'BALL_HIT'

export type Sounds = {
  [soundName in SoundNames]: {
    url: string
    audio: AudioBuffer | undefined
  }
}
export const SOUNDS: Sounds = {
  BALL_HIT: {
    url: 'bounceball-mini.wav',
    audio: undefined,
  }
}


export class SoundEngine {
  public soundEnabled = false
  private audioContext: AudioContext
  private soundsPlaying = 0
  private MAX_SOUNDS_PLAYING = 20

  constructor() {
    this.audioContext = new AudioContext()

    let sound: keyof Sounds
    for (sound in SOUNDS) {
      fetch(SOUNDS[sound].url).then(response => response.arrayBuffer().then(buffer => this.audioContext.decodeAudioData(buffer).then(decoded => SOUNDS[sound].audio = decoded)))
    }

  }

  public playSound(sound: keyof typeof SOUNDS, volume: number, detune = 0): void {
    if (!this.soundEnabled || this.soundsPlaying >= this.MAX_SOUNDS_PLAYING) {
      return
    }

    const source = this.audioContext.createBufferSource()
    source.buffer = SOUNDS[sound].audio ?? null

    const gain = this.audioContext.createGain()
    gain.gain.value = volume
    source.connect(gain)
    gain.connect(this.audioContext.destination)
    source.detune.value = detune + Math.random() * 1000

    source.addEventListener('ended', () => this.soundsPlaying--)
    this.soundsPlaying++
    source.start(0)
  }
}